import { render } from "./PositionBlockWrapper.vue?vue&type=template&id=88c0fd84&scoped=true"
import script from "./PositionBlockWrapper.vue?vue&type=script&lang=js"
export * from "./PositionBlockWrapper.vue?vue&type=script&lang=js"

import "./PositionBlockWrapper.vue?vue&type=style&index=0&id=88c0fd84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c0fd84"]])

export default __exports__